import HomePage from "./Pages/Homepage.js"
import "./App.css"




function App() {
  return (
    <div className="App">
    <HomePage/>
   
    
    </div>
  );
}

export default App;
